import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio as MuiRadio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import {
  ArticleLocationRow,
  InventoryStateTarget,
} from "./TransferLocationTable/types";

type Props = {
  open: boolean;
  row: ArticleLocationRow | null;
  targetStatus: InventoryStateTarget;
  quantity: number;
  maxEditable: number;
  availableQuantity: number;
  unavailableQuantity: number;
  submitting: boolean;
  onClose: () => void;
  onTargetStatusChange: (status: InventoryStateTarget) => void;
  onQuantityChange: (quantity: number) => void;
  onApply: () => void;
};

export default function TransferStateEditorDialog({
  open,
  row,
  targetStatus,
  quantity,
  maxEditable,
  availableQuantity,
  unavailableQuantity,
  submitting,
  onClose,
  onTargetStatusChange,
  onQuantityChange,
  onApply,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Editar estados de mercaderia</DialogTitle>
      <DialogContent>
        <Box pt={1} display="flex" flexDirection="column" gap={3}>
          <Typography variant="subtitle2">
            {row?.article?.code} - {row?.article?.description}
          </Typography>

          <Typography variant="body2">
            Un. Disp.: {availableQuantity} | Un. No Disp.: {unavailableQuantity}
          </Typography>

          <FormControl>
            <RadioGroup
              value={targetStatus}
              onChange={(event) =>
                onTargetStatusChange(event.target.value as InventoryStateTarget)
              }
            >
              <FormControlLabel
                value="available"
                control={<MuiRadio />}
                label="Disponible"
              />
              <FormControlLabel
                value="unavailable"
                control={<MuiRadio />}
                label="No disponible"
              />
            </RadioGroup>
          </FormControl>

          <Box display="flex" flexDirection="column" gap={1}>
            <TextField
              label="Cantidad"
              type="number"
              value={quantity}
              onChange={(event) =>
                onQuantityChange(Number(event.target.value) || 0)
              }
              inputProps={{
                min: 1,
                max: maxEditable,
              }}
            />
            <Typography variant="body2" color="text.secondary">
              Maximo editable para este estado: {maxEditable}
            </Typography>
            {maxEditable === 0 && (
              <Typography variant="body2" color="text.secondary">
                No hay unidades editables para mover al estado seleccionado.
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button
          onClick={onApply}
          variant="contained"
          disabled={
            submitting || maxEditable === 0 || quantity <= 0 || quantity > maxEditable
          }
        >
          {submitting ? "Aplicando..." : "Aplicar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
